module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/9-ceb2c3ec30fb64d379ce7398c3df4a3d.jpg";